import { Suspense } from 'react';

import { TooltipContent, TooltipProvider, TooltipTrigger } from '@radix-ui/react-tooltip';

import { Tooltip } from '../../ui/Tooltip';

const MarkdownIcon = () => {
  return (
    <svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.414 11H1.58597C1.37769 11 1.17146 10.9667 0.979043 10.9019C0.786625 10.8372 0.611789 10.7423 0.464519 10.6226C0.317248 10.503 0.200427 10.361 0.120724 10.2046C0.0410222 10.0483 0 9.88078 0 9.71158V1.28842C0 1.11922 0.0410222 0.951683 0.120724 0.795365C0.200427 0.639046 0.317248 0.497011 0.464519 0.37737C0.761945 0.135744 1.16534 0 1.58597 0H20.414C20.6223 0 20.8285 0.0333262 21.021 0.0980755C21.2134 0.162825 21.3882 0.257729 21.5355 0.37737C21.6828 0.497011 21.7996 0.639046 21.8793 0.795365C21.959 0.951683 22 1.11922 22 1.28842V9.71009C22.0001 9.87935 21.9592 10.047 21.8795 10.2034C21.7999 10.3598 21.6831 10.5019 21.5358 10.6216C21.3885 10.7413 21.2136 10.8363 21.0212 10.9011C20.8287 10.9659 20.6224 11 20.414 11ZM5.28777 8.42167V5.07028L7.40362 7.21889L9.51854 5.07028V8.42167H11.6344V2.57908H9.51854L7.40362 4.72769L5.28777 2.57908H3.17193V8.42316L5.28777 8.42167ZM19.4625 5.5H17.3466V2.57833H15.2317V5.5H13.1158L16.2887 8.50806L19.4625 5.5Z"
        fill="#D1D5DB"
      />
    </svg>
  );
};

interface Props {
  isLive: boolean;
}

const MarkDownHelperText = ({ isLive }: Props) => {
  return (
    <div className="space-y-2 text-sm">
      {isLive ? (
        <Suspense>
          <TooltipProvider delayDuration={0}>
            <Tooltip>
              <TooltipTrigger>
                <MarkdownIcon />
              </TooltipTrigger>
              <TooltipContent>
                <div className="absolute right-0 z-10 mt-2 flex flex-col space-y-2 rounded bg-gray-800 px-2 py-1 text-sm text-white text-left">
                  <p className="whitespace-nowrap">Simple markdown supported: </p>
                  <ul className="list-disc pl-4">
                    <li>*italics*</li>
                    <li>**bold**</li>
                    <li>***bold italics***</li>
                    <li>~~strike through~~</li>
                    <li>==highlight==</li>
                    <li>1. numbered list</li>
                  </ul>{' '}
                </div>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </Suspense>
      ) : (
        <MarkdownIcon />
      )}
    </div>
  );
};

export default MarkDownHelperText;
